import React, { useMemo } from "react";
import { useEffect, useRef } from "react";
import { useSection } from "../SectionContext/SectionContext";

function BtnAccueil() {
  const { activeSection, setActiveSection } = useSection();

  const toggleSection = () => {
    setActiveSection((prevSection) =>
      prevSection === "banners" ? "portfolio" : "banners"
    );
  };

  const bannerRef = useRef(null);

  const blockRefs = useMemo(() => {
    return Array(90)
      .fill(0) // Remplit chaque élément du tableau avec la valeur 0
      .map((_, i) => React.createRef()); // Le _ est une convention pour indiquer que nous n'utilisons pas la valeur de l'élément (parce que nous ne nous soucions que de l'index i)Pour chaque index i, on crée un nouvel objet React.createRef().100 références  créées chacune à l'aide de React.createRef()
  }, []);

  useEffect(() => {
    for (let i = 0; i < 90; i++) {
      const duration = Math.random() * 5;
      blockRefs[i].current.style.animationDuration = `${duration}s`;
    }
  }, [blockRefs]);

  return (
    <>
      <div className="banner" ref={bannerRef} onClick={toggleSection}>
        {blockRefs.map((ref, i) => (
          <div key={i} className="blocks" ref={ref}></div>
        ))}
        <span>{activeSection === "banners" ? "Projets" : "Accueil"}</span>
      </div>
    </>
  );
}

export default BtnAccueil;
